import { global_trigall_hero } from '../../utils/requests/contentstack/contentStackZodSchema';
import { type TrigallHeroProps } from '.';
import { getCloudinaryImageFields } from '../../utils/getCloudinaryItem/getCloudinaryItem';

export const trigallHeroSchema =
  global_trigall_hero.transform<TrigallHeroProps>(data => ({
    title: data.title,
    buttonCopy: data.button.title,
    buttonHref: data.button.href,
    description: data.description,
    mobileImage: getCloudinaryImageFields({
      alt: data.mobile_image.alt,
      cloudinaryField: data.mobile_image.src,
      shouldUseV2: true,
    }),
    leftImage: getCloudinaryImageFields({
      alt: data.left_image.alt,
      cloudinaryField: data.left_image.src,
      shouldUseV2: true,
    }),
    topRightImage: getCloudinaryImageFields({
      alt: data.top_right_image.alt,
      cloudinaryField: data.top_right_image.src,
      shouldUseV2: true,
    }),
    bottomRightImage: getCloudinaryImageFields({
      alt: data.bottom_right_image.alt,
      cloudinaryField: data.bottom_right_image.src,
      shouldUseV2: true,
    }),
  }));
